/* SEW Assistant - first-visit teaser bubble.
   Sits above the launcher, says something useful for the page the visitor is on,
   and gets out of the way once it has been seen or dismissed.

   How often it appears is set in the theme editor:
     always   - every page view
     session  - once per browsing session
     quiet    - once every three days per visitor

   Testing from the browser console:
     sewBotTease()        show it now, ignoring every rule
     sewBotTease.why()    print the reason it stayed hidden
     sewBotTease.reset()  clear the teaser and chat history, then reload */
(function () {
  'use strict';

  var FREQ = (window.SEW_TEASE_FREQ || 'session').trim();
  var SEEN_KEY = 'sew_bot_teased';
  var SESSION_KEY = 'sew_bot_teased_session';
  var CHAT_KEY = 'sew_bot_chat_v1';
  var QUIET_DAYS = 3;
  var BUSY_HOURS = 2;
  var AUTO_HIDE = 18000;
  var FREE_OVER = 3000;

  function money(n) { return 'Rs. ' + Number(n).toLocaleString('en-PK'); }

  function reasonToSkip() {
    if (!document.querySelector('.sewb-fab')) return 'the chat widget has not loaded';
    var panel = document.querySelector('.sewb-panel');
    if (panel && panel.classList.contains('on')) return 'the chat panel is already open';

    if (FREQ === 'always') return null;

    try {
      if (FREQ === 'session') {
        if (sessionStorage.getItem(SESSION_KEY)) return 'it has already appeared in this browsing session';
        return null;
      }
      var t = parseInt(localStorage.getItem(SEEN_KEY) || '0', 10);
      if (t && (Date.now() - t) < QUIET_DAYS * 86400000) {
        return 'this visitor was already shown the bubble within the last ' + QUIET_DAYS + ' days';
      }
      var d = JSON.parse(localStorage.getItem(CHAT_KEY) || 'null');
      if (d && d.msgs && d.msgs.length && (Date.now() - d.t) < BUSY_HOURS * 3600000) {
        return 'this visitor was chatting less than ' + BUSY_HOURS + ' hours ago';
      }
    } catch (e) {}
    return null;
  }

  function markSeen() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
      localStorage.setItem(SEEN_KEY, String(Date.now()));
    } catch (e) {}
  }

  function getJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  /* Whichever of these is true first decides what the bubble says. */
  function buildMessage(cb) {
    getJSON('/cart.js')
      .then(function (cart) {
        if (cart && cart.item_count) {
          var total = Math.round(cart.total_price / 100);
          var gap = FREE_OVER - total;
          if (gap > 0) {
            cb({
              title: money(gap) + ' from free delivery',
              body: 'Free within Karachi at ' + money(FREE_OVER) + '. I can show you what would close the gap.'
            });
          } else {
            cb({
              title: 'Your delivery is free',
              body: 'Karachi orders over ' + money(FREE_OVER) + ' ship free. Any questions before you check out?'
            });
          }
          return;
        }
        productPrompt(cb);
      })
      .catch(function () { productPrompt(cb); });
  }

  function productPrompt(cb) {
    var h = productHandle();
    if (!h) {
      cb({
        title: 'Looking for something?',
        body: 'I can help you find a piece, or answer questions about delivery and returns.'
      });
      return;
    }
    getJSON('/products/' + h + '.js')
      .then(function (p) {
        cb({
          title: 'Questions about this piece?',
          body: 'I can check stock, price and delivery for ' + (p.title || 'this product') + '.'
        });
      })
      .catch(function () {
        cb({ title: 'Questions about this piece?', body: 'I can check stock, price and delivery for you.' });
      });
  }

  function show(msg) {
    var fab = document.querySelector('.sewb-fab');
    if (!fab) { console.warn('SEW Assistant: launcher not found, bubble skipped.'); return; }

    var old = document.querySelector('.sewb-tease');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var host = document.querySelector('.sewb') || document.body;
    var el = document.createElement('div');
    el.className = 'sewb-tease';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.innerHTML =
      '<button class="sewb-tease-x" aria-label="Dismiss">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button><b></b><span></span>';
    el.querySelector('b').textContent = msg.title;
    el.querySelector('span').textContent = msg.body;
    host.appendChild(el);
    markSeen();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('on'); });
    });

    function close(open) {
      el.classList.remove('on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 320);
      if (open) fab.click();
    }

    el.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sewb-tease-x')) { close(false); return; }
      close(true);
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(true); }
    });

    setTimeout(function () { if (el.parentNode) close(false); }, AUTO_HIDE);
  }

  window.sewBotTease = function () { buildMessage(show); };
  window.sewBotTease.why = function () {
    var r = reasonToSkip();
    console.log(r ? 'Bubble hidden because ' + r + '.' : 'Nothing is blocking the bubble. Frequency is set to "' + FREQ + '".');
    return r;
  };
  window.sewBotTease.reset = function () {
    try {
      localStorage.removeItem(SEEN_KEY);
      localStorage.removeItem(CHAT_KEY);
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) {}
    console.log('Teaser and chat history cleared. Reload the page.');
  };

  /* Appear as soon as the launcher is on the page, not on a fixed timer. */
  var tries = 0;
  (function start() {
    if (document.visibilityState !== 'visible') return;
    if (document.querySelector('.sewb-fab')) {
      if (reasonToSkip()) return;
      buildMessage(show);
      return;
    }
    if (++tries > 40) return;
    setTimeout(start, 100);
  })();
})();
